<template>
  <div></div>
</template>

<script>
export default {
  name: `Index`
};
</script>
